import React from 'react';
import ListTabs from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/ListTabs';
import ReviewUnknownsTable from './ReviewUnknownsTable';
import { useFormPayloadContext } from '@/creditflowresearch/application/PortfolioMonitor/FormPayloadContext';

const ReviewUnknowns = (props) => {
  const {
    payload: { lists = [] },
    activeListName,
    setActiveListName,
  } = useFormPayloadContext();

  const tabLists = lists.map(({ name }) => ({
    key: name, name, isDisabled: false,
  }));

  return (
    <>
      <ListTabs lists={ tabLists } selectedTab={ activeListName } onChange={ setActiveListName } />
      <ReviewUnknownsTable { ...props } />
    </>
  );
};

export default ReviewUnknowns;
